import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import clsx from "clsx";
import useAppSelector from "@/core/helpers/useAppSelector";
import {
  estateSelectSelectedTabSelector,
  estateSelectTabsSelector,
  setSlotsSelectedTab,
} from "@/domains/estate/slice";

export default function EstateEstateSelectTabsContainer() {
  const { t } = useTranslation("estate");
  const dispatch = useDispatch();
  const [isFirstOpen, setIsFirstOpen] = useState(true);
  const estateSelectTabs = useAppSelector(estateSelectTabsSelector);
  const selectedEstateSelectTab = useAppSelector(estateSelectSelectedTabSelector);
  const [activeTabBlockStyle, setActiveTabBlockStyle] = useState({ width: 0, left: 0 });
  const refs = useRef([]);

  useLayoutEffect(() => {
    const index = estateSelectTabs.findIndex((tab) => tab === selectedEstateSelectTab);
    if (refs.current[index]) {
      const activeTabElement = refs.current[index];
      const { offsetWidth, offsetLeft } = activeTabElement;

      setActiveTabBlockStyle({
        width: offsetWidth,
        left: offsetLeft,
      });
    }
  }, [selectedEstateSelectTab, estateSelectTabs]);

  useEffect(() => setIsFirstOpen(false), []);

  return (
    <div className="relative flex items-center shrink-0 w-full h-[2.75rem] bg-dark-800 rounded-[0.5rem]">
      {estateSelectTabs.map((tab, index) => (
        <button
          type="button"
          key={tab}
          ref={(el) => {
            refs.current[index] = el;
            return el;
          }}
          className={clsx(
            "h-full px-5 hover:text-white transition-all duration-300 text-11 font-bold z-1 uppercase",
            selectedEstateSelectTab === tab ? "text-white" : "text-white/50",
          )}
          onClick={() => dispatch(setSlotsSelectedTab(tab))}
        >
          {t(`estate.slots.tab.${tab}`)}
        </button>
      ))}

      <div
        className="absolute h-full bg-gradient-red rounded-[0.5rem] duration-300 z-0"
        style={{
          width: `${activeTabBlockStyle.width}px`,
          transform: `translateX(${activeTabBlockStyle.left}px)`,
          transitionProperty: isFirstOpen ? "none" : "all",
        }}
      />
    </div>
  );
}
